var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33569",
    "data-name": "Group 33569",
    transform: "translate(126 136) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(108 118)",
    opacity: 0.003
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 18,
    height: 18,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(125.03 135.037) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67897",
    "data-name": "Path 67897",
    d: "M8.92,2.9l.015,9.824h2.008l-.015-9.811,1.85,1.848L14.2,3.344,11.574.723a2.342,2.342,0,0,0-3.313,0L5.639,3.346,7.058,4.764Z",
    transform: "translate(17.971 12.764) rotate(180)",
    fill: "#5076ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67898",
    "data-name": "Path 67898",
    d: "M14.054,16v3.346H2.008V16H0v3.346a2.008,2.008,0,0,0,2.008,2.008H14.054a2.008,2.008,0,0,0,2.008-2.008V16Z",
    transform: "translate(0 -5.28)",
    fill: "#5076ba"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.79b404860db9cad9df4f686eb964f515.svg";
export { ForwardRef as ReactComponent };